module.exports = __webpack_public_path__ + "media/images/patterns/6-a2039cc35e82aaee900c0d3d47cbf5f3.png";